module.exports = __webpack_public_path__ + "static/media/YF106_4.f0f596ad.jpg";